/** Whether the PostHog SDK may contact a real or proxied analytics host. */
export function shouldInitializePostHog(
  token: unknown,
  e2eEnabled: boolean,
): boolean {
  if (e2eEnabled) return false
  if (typeof token !== 'string') return false
  const candidate = token.trim()
  if (!candidate || /^\$[A-Z0-9_]+$/.test(candidate)) return false
  return true
}
